import { HiOutlineDocumentCheck } from "react-icons/hi2"
import { MdOutlineTaskAlt } from "react-icons/md"
import { UIPaths } from "../router/UIPaths"
import appConstants from "./app.constants"

const notificationConstants = {
	13601: { caption: 'Task', icon: <MdOutlineTaskAlt />, color: 'success', url: UIPaths.allTask, activityID: appConstants.activity.myTasks},
	13602: { caption: 'Circular', icon: <HiOutlineDocumentCheck />, color: 'primary',url:UIPaths.circular ,activityID: appConstants.activity.circular }
	
}

export default notificationConstants
